import { Routes } from '@angular/router';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { QuestionnairesListPageComponent } from './features/questionnaires/features/table-grid/features/questionnaires-list-page/questionnaires-list-page.component';
import { CreateQuestionnairePageComponent } from './features/create-questionnaire-page/create-questionnaire-page.component'; import { RemindersComponent } from './features/reminders/reminders.component';
import { CreateQuestionnaireWarpComponent } from './features/create-questionnaire-warp/create-questionnaire-warp.component';
import { PreviewComponent } from './features/warp-preview/preview/preview.component';
import { WarpPreviewComponent } from './features/warp-preview/warp-preview.component';
import { QuestionnaireDataComponent } from './features/questionnaires/features/table-grid/features/questionnaire-data/questionnaire-data.component';
import { SummaryComponent } from './features/questionnaires/features/table-grid/features/questionnaire-data/components/summary/summary.component';
import { SumbissionsComponent } from './features/questionnaires/features/table-grid/features/questionnaire-data/components/sumbissions/sumbissions.component';
import { ApiExposureComponent } from './features/questionnaires/features/table-grid/features/questionnaire-data/components/api-exposure/api-exposure.component';
import { ApprovalComponent } from './features/approval/approval.component';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { ErrorPageComponent } from './shared/components/error-page/error-page.component';
import { QuestionsCollectionComponent } from './features/collections/components/questions-collection/questions-collection.component';
import { MsalGuard } from '@azure/msal-angular';
import { DesktopGuard } from './desktop-guard.service';
import { QuestionnairesListComponent } from './features/questionnaires/features/table-grid/features/questionnaires-list-page/components/questionnaires-list/questionnaires-list.component';
import { AnsweredTheQuestionnaireComponent } from './features/questionnaires/features/table-grid/features/questionnaire-data/components/answered-the-questionnaire/answered-the-questionnaire.component';
import { DistributionGroupComponent } from './features/distribution-group/distribution-group.component';
import { AdminGuard, ApproverAdminGuard } from './roles-guard.service';
import { AppWarpComponent } from './app-warp/app-warp.component';
import { SavedListComponent } from './features/saved-list/saved-list.component';
import { CanEditGuard } from './can-edit-guard';
import { CanAnswerGuard } from './can-answer.guard';
import { SaveQuestionnarieGuard } from './save-questiionarie-guard';
import { RemoveTostesGuard } from './guards/remove-tostes-guard';
import { generalGuad } from './services/auth.guard';
import { environment } from 'src/environment';
import { LoginGetwayComponent } from './features/login/login-getway/login-getway.component';
import { InitGuard } from './services/init.guard';
import { UnauthorizedRedirectGuard } from './guards/unauthorized-url-redirect.guard';
import { ApprovalsComponent } from './features/approvals/approval/approvals.component';
import { ViewAnswersComponent } from './features/view-answers/view-answers.component';
import { ViewFileComponent } from './features/view-file/view-file/view-file.component';

const routesApp: Routes = [
  {
    path: 'answer/questionnaire/:id',
    component: WarpPreviewComponent,
    title: environment.title,
    canActivate: [UnauthorizedRedirectGuard],
  },
  {
    path: 'answer/:guid',
    component: WarpPreviewComponent,
    title: environment.title,
    canActivate: [CanAnswerGuard],
  },
  {
    path: 'approval',
    component: ApprovalComponent,
    title: environment.title,
  },
  {
    path: 'home',
    title: environment.title,
    redirectTo: 'main'
  },
  {
    path: 'main',
    component: MainLayoutComponent,
    title: environment.title,
    children: [
      {
        path: 'grid',
        component: QuestionnairesListPageComponent,
        children: [
          {
            path: 'questionnaires',
            component: QuestionnairesListComponent,
          },
          {
            path: 'distributionGroups',
            component: DistributionGroupComponent,
            canActivate: [AdminGuard],
          },
          {
            path: 'smartQuestions',
            component: QuestionsCollectionComponent,
            canActivate: [AdminGuard],
          },
          {
            path: 'savedLists',
            component: SavedListComponent,
            canActivate: [AdminGuard],
          },
          {
            path: 'reminders',
            component: RemindersComponent,
            canActivate: [AdminGuard],
          },
          {
            path: 'approvals',
            component: ApprovalsComponent,
            canActivate: [ApproverAdminGuard],
          },
          { path: '', pathMatch: 'full', redirectTo: 'questionnaires' },
        ]
      },
      { path: '', pathMatch: 'full', redirectTo: 'grid' },
    ]
  },
  {
    path: 'data/:id',
    component: QuestionnaireDataComponent,
    title: environment.title,
    canActivate: [DesktopGuard, AdminGuard],
    canDeactivate: [RemoveTostesGuard],
    children: [
      {
        path: 'summary',
        component: SummaryComponent
      },
      {
        path: 'submissions',
        component: SumbissionsComponent
      },
      {
        path: 'answeredTheQuestionnaire',
        component: AnsweredTheQuestionnaireComponent
      },
      {
        path: 'apiExposure',
        component: ApiExposureComponent
      },
      { path: '', pathMatch: 'full', redirectTo: 'answeredTheQuestionnaire' }
    ]
  },
  {
    path: 'create/:id',
    component: CreateQuestionnaireWarpComponent,
    canActivate: [DesktopGuard, AdminGuard],
    title: environment.title,
    children: [
      {
        path: 'board',
        component: CreateQuestionnairePageComponent,
        canActivate: [CanEditGuard],
        canDeactivate: [SaveQuestionnarieGuard]
      },
      {
        path: 'preview',
        component: PreviewComponent,
      },
      { path: '', pathMatch: 'full', redirectTo: 'board' },
    ]
  },
  {
    path: 'viewAnswers/:guid/:status',
    component: ViewAnswersComponent,
    title: environment.title,
  },
  {
    path: 'viewFile/:guid',
    component: ViewFileComponent,
    title: environment.title,
  },
  {
    path: 'notFound',
    component: NotFoundComponent,
    title: environment.title,
  },
  {
    path: 'error',
    component: ErrorPageComponent,
    title: environment.title,
  },
  {
    path: '', pathMatch: 'full', redirectTo: 'main', title: environment.title,
  },
];
export const authGuard = () => {
  return environment.auth === "azure" ? MsalGuard : generalGuad;
};

const loginPage = environment.auth !== "jwt" ? [] : [{
  path: "login",
  component: LoginGetwayComponent,
  canActivate: [InitGuard],
  title: environment.title,
}];

const adminLoginPage = environment.adminLoginMethod ? [{
  path: "adminLogin",
  component: LoginGetwayComponent,
  canActivate: [InitGuard],
  title: environment.title,

}] : [];

export const routes: Routes = [{
  path: '',
  component: AppWarpComponent,
  children: [{
    path: '',
    loadChildren: () => routesApp,
  }],
  canActivate: [InitGuard, authGuard()],
},
...loginPage,
...adminLoginPage,
{
  path: "404",
  component: NotFoundComponent,
  canActivate: [InitGuard],
}]